<mat-chip-listbox>
  @let searchString = presetPropertySearch()?.searchString;
  @if (searchString) {
    <mat-chip-option>
      '{{searchString}}'
      <mat-icon color="warn" matChipRemove (click)="remove('searchString')">cancel</mat-icon>
    </mat-chip-option>
  }
</mat-chip-listbox>
